import type { Session } from '@edil/api-client';

// localStorage can be unavailable (private mode, Telegram in-app browsers with storage off):
// every access is guarded and the app keeps working in memory.
const memory = new Map<string, string>();

export function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return memory.get(key) ?? null;
  }
}

export function write(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    if (value === null) memory.delete(key);
    else memory.set(key, value);
  }
}

export function loadSession(): Session | null {
  try {
    const raw = read('edil.session');
    return raw ? (JSON.parse(raw) as Session) : null;
  } catch {
    return null;
  }
}

export function saveSession(s: Session | null): void {
  write('edil.session', s ? JSON.stringify(s) : null);
}

export function deviceId(): string {
  let id = read('edil.device');
  if (!id) {
    id = crypto.randomUUID();
    write('edil.device', id);
  }
  return id;
}
